<nz-card
    class="messageCard"
    [ngClass]="{ unread: message.WasRead == 'N',clicked:sharedMessageId===message.Code }"
    (click)="openMessageDetails(message.Code)"
    >
    <nz-card-meta
      nzTitle="{{ message.U_NAME }}"
      nzDescription="{{ removeFromString(message.Subject) }}"
    ></nz-card-meta>
    <span
      class="starIcon"
      (click)="changeStarringStatues(message.Code, message.Starred)"
      [ngClass]="{ starred: message.Starred == 'Y' }"
    >
    <i class="fas fa-star" *ngIf="message.Starred == 'Y'"></i>
    <i class="far fa-star" *ngIf="message.Starred != 'Y'"></i>
    </span>
    <span class="CardDate">
      {{ message.RecDate }} - {{ message.RecTime }}
    </span>
  </nz-card>
